import React from 'react';
import CustomiseTable from '../../components/CustomiseTable';
import { Box, Button, Typography, useMediaQuery, useTheme } from '@mui/material';
import { CustomChip } from '../../components/CustomChip';
import DownloadIcon from '../../icons/DownloadIcon';
import TableList from '../../components/TableList';
import { format } from 'date-fns';
import { CompanyBadge } from '../../components/CompanyBadge';
import { PaymentIcon } from 'react-svg-credit-card-payment-icons';
import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import TransactionPDF from '../../components/TransactionPDF';

const TableHeadRowList = [
    {
        id: 'invoice',
        name: 'Invoice',
        hideCellValue: true,
        renderElement: (row) => {
            return (
                <>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'start',
                            alignItems: 'center',
                        }}
                    >
                        {row.name}
                        <CustomChip
                            label={row.type === 'Refund' ? 'Refund' : 'Paid'}
                            variant="outlined"
                            color={row.type === 'Refund' ? 'error' : 'success'}
                            sx={{
                                marginLeft: '0.5rem',
                                '& .MuiChip-label': {
                                    padding: '3px 5px',
                                },
                            }}
                        />
                    </Box>
                    {/* <Box>
                        <Typography variant="body2" color="text.neutralSecondary" fontSize={'customFontSize.small'} fontWeight={'fontWeightRegular'} lineHeight={1.5}>
                            {row.name}
                        </Typography>
                    </Box> */}
                </>
            );
        },
    },
    {
        id: 'company',
        name: 'Company',
        hideCellValue: true,
        renderElement: (row) => {
            return row?.accountName && <CompanyBadge accountName={row.accountName} accountId={row.accountId} isLink openInNewTab/>;
        },
    },
    {
        id: 'lastTransactionDate',
        name: 'Transaction Date',
        renderElement: (row) => {
            return (
                <Typography component={'span'} color={'text.neutralSecondary'} fontSize={'customFontSize.small'} lineHeight={'150%'}>
                    {row.gatewayDateString}
                </Typography>
            );
        },
    },
    {
        id: 'cardDetails',
        name: 'Card Details',
        renderElement: (row) => {
            return (
                <Box display={'flex'} alignItems={'center'}>
                    <PaymentIcon type={row.cardType?.toLowerCase()} format="flatRounded" width={25} />
                    <Typography variant="body2" fontSize={'customFontSize.xSmall'} marginLeft={'0.5rem'} sx={{ color: row.ccExpiringSoon ? 'red' : 'inherit' }}>
                        <span style={{ color: 'gray' }}>{'Card ending in '}</span>
                        {row.cardLast4}
                    </Typography>{' '}
                </Box>
            );
        },
    },
    {
        id: 'amount',
        name: 'Amount',
        renderElement: (row) => {
            return (
                <Typography component={'span'} color={'text.neutralSecondary'} fontSize={'customFontSize.small'} lineHeight={'150%'}>
                    {new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: 'USD',
                        maximumFractionDigits: 2,
                    }).format(row.amount)}
                </Typography>
            );
        },
    },
    {
        id: 'actions',
        name: <span style={{}}>Action</span>,
        hideLeftCell: true,
        rightCellSx: {
            width: {
                xs: '100%',
                sm: 'unset',
            },
        },

        renderElement: (row, _, index) => {
            return (
                <Box>
                    {/* preview of document pdf of first row data */}
                    {/* {index === 0 && (
                        <>
                            <PDFViewer width="80%" height="100%" style={{
                                position:'absolute',
                                top:0,
                                left:0,
                                zIndex:999999
                            }}>
                                <TransactionPDF record={row} />
                            </PDFViewer>
                        </>
                    )} */}
                    <PDFDownloadLink document={<TransactionPDF record={row} />} fileName={`Transaction-${row.name}.pdf`}>
                        {({ blob, url, loading, error }) => (
                            <Button disabled={loading} variant="outlined" color="primary" startIcon={<DownloadIcon />} size="small" sx={{ marginRight: '0.5rem' }}>
                                Download
                            </Button>
                        )}
                    </PDFDownloadLink>
                </Box>
            );
        },
    },
];

function PaymentInvoiceTableAndList({ tableBodyRowList = undefined }) {
    const theme = useTheme();
    const isMobileView = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <>
            {!isMobileView ? (
                <CustomiseTable
                    columns={TableHeadRowList}
                    rows={tableBodyRowList}
                    componentStyleProps={{
                        tableHeaderCellSx: {
                            background: '#F2F3F5',
                            borderColor: theme.palette.gray[200],

                            color: theme.palette.text.secondary,
                            fontSize: theme.typography.customFontSize.xSmall, // 12px

                            fontWeight: theme.typography.fontWeightMedium,
                            lineHeight: '150%',
                        },

                        tableBodyCellSx: {
                            background: theme.palette.background.paper,
                            color: theme.palette.text.secondary,
                            borderColor: theme.palette.gray[200],
                            fontSize: theme.typography.customFontSize.small, // 14px
                            fontWeight: theme.typography.fontWeightRegular,
                            lineHeight: '150%',
                        },
                    }}
                />
            ) : (
                <TableList
                    columns={TableHeadRowList}
                    rows={tableBodyRowList}
                    componentStyleProps={{
                        tableListSx: {
                            paddingBottom: '1rem',
                        },
                    }}
                />
            )}
        </>
    );
}

export default PaymentInvoiceTableAndList;
